import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../Config/apiConfig";
import { Link } from "react-router-dom";
import { FaHeart, FaStar } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";


const Searchproduct = () => {
   const [searchParams] = useSearchParams();
   const [products, setProducts] = useState([]); // ⭐ state

  const keyword = searchParams.get("keyword");

  useEffect(() => {

    const fetchSearchProducts = async () => {

      try {

        const res = await axios.get(
          `http://localhost:8500/api/v1/search?keyword=${keyword}`
        );

        console.log("Search API:", res.data);

      // ⭐ sirf products show karna
      setProducts(res.data.products || []);

    } catch (err) {
      console.error("Search error:", err);
    }

  };

  if (keyword) {
    fetchSearchProducts();
  }

}, [keyword]);
  // ⭐ Render Stars
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <FaStar
        key={index}
        size={15}
        className={index < rating ? "text-[#F9AE0E]" : "text-gray-300"}
      />
    ));
  };

  return (
    <div className="py-14 bg-white">
      <div className="max-w-[1400px] mx-auto px-4">

        {/* TITLE */}
        <h2 className="text-center text-[26px] sm:text-[32px] lg:text-[38px] font-bold text-[#3A8DF5] mb-12">
          Our Featured Medicines
        </h2>

        {/* GRID */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {products.map((product) => {

            // ⭐ Rating Logic (PER PRODUCT)
            const reviews = product.review || [];
            const avgRating =
              reviews.length > 0
                ? Math.round(
                    reviews.reduce(
                      (sum, r) => sum + Number(r.rating || 0),
                      0
                    ) / reviews.length
                  )
                : 0;

            return (
              <div
                key={product._id}
                className="bg-white rounded-[28px] p-4 shadow-sm relative hover:shadow-md transition"
              >

                {/* ❤️ Heart */}
                <div className="absolute top-4 right-4 text-red-500">
                  <FaHeart size={20} />
                </div>

                {/* Image */}
                <Link to={`/product/${product._id}`} state={{ product }}>
                  <div className="bg-[#FAFAFA] rounded-[22px] h-[230px] flex items-center justify-center">
                    <img
                      src={`https://mediapi.onlinepharmaque.in/uploads/${product.pImg?.[0]}`}
                      alt={product.pName}
                      className="h-[190px] object-contain"
                    />
                  </div>
                </Link>

                {/* Name */}
                <p className="mt-4 text-[16px] font-semibold leading-snug line-clamp-2">
                  {product.pName}
                </p>

                {/* Qty */}
                <p className="text-[14px] text-gray-400 mt-1">
                  3 X 100ml
                </p>

                {/* Price & Rating */}
                <div className="flex items-center justify-between mt-4">

                  {/* Price */}
                  <div className="flex items-center gap-2">
                    <span className="text-[20px] font-bold text-[#187685]">
                      ₹{product.price}
                    </span>
                    {product.discountPrice && (
                      <span className="text-[15px] line-through text-gray-400">
                        ₹{product.discountPrice}
                      </span>
                    )}
                  </div>

                  {/* ⭐ Rating */}
                  <div className="flex gap-[3px]">
                    {renderStars(avgRating)}
                  </div>

                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Searchproduct;
